import request from '@/utils/request'
const version_url = '/v2'
export function getList (params) {
  return request({
    url: version_url + '/table/list',
    method: 'get',
    params
  })
}
export function getTemplateList (params) {
  return request({
    url: version_url + '/js/template/list',
    method: 'get',
    params
  })
}
export function addTemplate (data) {
  return request({
    url: version_url + '/js/template/create',
    method: 'post',
    data: data
  })
}
export function getTemplateInfo (params) {
  return request({
    url: version_url + '/js/template/getJsById',
    method: 'get',
    params
  })
}
export function deleteTemplate (params) {
  return request({
    url: version_url + '/js/template/deleteById',
    method: 'get',
    params
  })
}
export function getAllTemplateInfo (params) {
  return request({
    url: version_url + '/js/template/ListId',
    method: 'get',
    params
  })
}
export function updateTemplate (data) {
  return request({
    url: version_url + '/js/template/update',
    method: 'post',
    data
  })
}

// 入口js配置
export function getConfigCreate (data) {
  return request({
    url: version_url + '/js/config/create',
    method: 'post',
    data
  })
}
export function getConfigUpdate (data) {
  return request({
    url: version_url + '/js/config/update',
    method: 'post',
    data
  })
}
export function getConfigGetById (params) {
  return request({
    url: version_url + '/js/config/getById',
    method: 'get',
    params
  })
}
export function getConfigList (params) {
  return request({
    url: version_url + '/js/config/list',
    method: 'get',
    params
  })
}
export function getConfigDeleteById (params) {
  return request({
    url: version_url + '/js/config/deleteById',
    method: 'get',
    params
  })
}
export function getConfigListId (params) {
  return request({
    url: version_url + '/js/config/ListId',
    method: 'get',
    params
  })
}
export function configReleaseApi (params) {
  return request({
    url: version_url + '/js/config/release',
    method: 'get',
    params
  })
}
// 广告位
export function getAdCreate (data) {
  return request({
    url: version_url + '/js/ad/create',
    method: 'post',
    data
  })
}
export function getAdUpdate (data) {
  return request({
    url: version_url + '/js/ad/update',
    method: 'post',
    data
  })
}
export function getAdGetJsById (params) {
  return request({
    url: version_url + '/js/ad/getById',
    method: 'get',
    params
  })
}
export function getAdList (params) {
  return request({
    url: version_url + '/js/ad/list',
    method: 'get',
    params
  })
}
export function getAdDeleteById (params) {
  return request({
    url: version_url + '/js/ad/deleteById',
    method: 'get',
    params
  })
}
export function getAdRelease (params) {
  return request({
    url: version_url + '/js/ad/release',
    method: 'get',
    params
  })
}
